import React from "react";
// import OurTeamHeroSection from "../../components/user/OurTeam/OurTeamHeroSection";
import OurTeamBodyContainer from "../../components/user/OurTeam/OurTeamBodyContainer";
import OurTeamInfoContainer2 from "../../components/user/OurTeam/OurTeamInfoContainer2";
import OurTeaminfoContainer1 from "../../components/user/OurTeam/OurTeaminfoContainer1";
import NavigationBanner from "../../components/common/NavigationBanner";
import HeaderBg from "../../Assets/Images/our-team/OurTeam_BG.png";

const OurTeam = () => {
  return (
    <div className="w-full overflow-x-hidden">
      <NavigationBanner title={"Our Team"} background={HeaderBg} />
      {/* <OurTeamHeroSection /> */}
      <OurTeamBodyContainer />
      <OurTeaminfoContainer1 />
      <OurTeamInfoContainer2 />
    </div>
  );
};

export default OurTeam;
